var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectdItem.preStyle.selfStyle)?_c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticStyle:{"max-width":"100%"},style:({
	 	..._vm.getBorder(),
	 	..._vm.getBorderRadius(),
	 	..._vm.getBg(_vm.selectdItem),
		..._vm.getImgStyle(_vm.selectdItem)
	 })})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }